import { type ProductFragment } from '../fragments/ProductFragment';

const mapProductFragmentToListProduct = (product: ProductFragment) => {
  const variants = (product.variants ?? [])
    .filter((variant) => variant !== null)
    .map((variant) => ({
      ...variant,
      id: Number(variant.id),
      variantId: Number(variant.variantId),
      productId: Number(variant.productId),
      // eslint-disable-next-line @typescript-eslint/non-nullable-type-assertion-style
      price: product.price?.amount as number,
    }));
  return {
    ...product,
    id: Number(product.id),
    variants,
  };
};

export type ListProduct = ReturnType<typeof mapProductFragmentToListProduct>;
export type Variant = ListProduct['variants'][number];

export default mapProductFragmentToListProduct;
